module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cYa7h"))).then(() => parcelRequire('d0iPb'));